import AircraftModel from "../aircraft/AircraftModel";
import Attack from "./Attacks";

class DuplicationAttack extends Attack {
    /**
     * 
     * @param {number} startTimestamp 
     * @param {AircraftModel} aircraftToDuplicate 
     */
	constructor(startTimestamp, aircraft, aircraftToDuplicate) {
		super(startTimestamp);

        /**
         * The aircraft to duplicate
         * 
         * @type {AircraftModel}
         * @default null
         */
        this.aircraftToDuplicate = aircraftToDuplicate;

		this.init(aircraft);
	}

    /**
     * Initialize the attack
     * 
     * @method init
     * @param {AircraftModel} aircraft - the duplicate aircraft
     */
	init(aircraft) {
		super.init();

        aircraft.airlineId = this.aircraftToDuplicate.airlineId;
        aircraft.airlineCallsign = this.aircraftToDuplicate.airlineCallsign;
        aircraft.altitude = this.aircraftToDuplicate.altitude;
        aircraft.flightNumber = this.aircraftToDuplicate.flightNumber;
        aircraft.icao = this.aircraftToDuplicate.icao;
        aircraft.model = this.aircraftToDuplicate.model;
        aircraft.origin = this.aircraftToDuplicate.origin;
        aircraft.destination = this.aircraftToDuplicate.destination;
        aircraft.transponderCode = this.aircraftToDuplicate.transponderCode;
        aircraft.speed = this.aircraftToDuplicate.speed;
        aircraft.category = this.aircraftToDuplicate.category;

	}

	update() {
		
	}
	
	end(endTimestamp) {
		super.end(endTimestamp);
	}
}

export default DuplicationAttack;